import React from "react";

export default function BuketsTableSoc_Jupiter(props) {
  let { data } = props;
  return (
    <>
      {(data.length == 0) ? "<tr><td colSpan={2}>No data found</td></tr>" : data.map((x, index) => {
        return (<tr key={x.key}>
          <td scope="row ">{x.key}</td>
          <td >{(x.delta_soc.values["50.0"]).toFixed(2)} </td>
        </tr>)
      })}
    </>
  );
}